import React from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { motion } from "framer-motion";
import { Search, TrendingUp } from "lucide-react";

const PHASES = [
  {
    id: 1,
    overline: "Semaine 1 à 6",
    caption: "Mise en place",
    title: "PHASE 1 : MISE EN PLACE & STRATÉGIE",
    icon: Search,
    image: "/phase1.png",
  },
  {
    id: 2,
    overline: "Semaine 7 à 12",
    caption: "Optimisations",
    title: "PHASE 2 - EXÉCUTION ET OPTIMISATION",
    icon: TrendingUp,
    image: "/phase2.png",
  },
];

export default function ClientParcours() {
  const navigate = useNavigate();
  const { customProg } = useOutletContext() || {};
  const phases = customProg ? [{ ...PHASES[0], title: "PHASE 1 : AUDIT ET RESTRUCTURATION DE TON BUSINESS", overline: "Audit", caption: "Restructuration" }, { ...PHASES[1], overline: "Exécution" }] : PHASES;

  return (
    <div className="max-w-5xl space-y-8">
      <div>
        <h1 className="mt-2 font-sans text-3xl font-medium text-ink sm:text-4xl">Le programme</h1>
        <p className="mt-2 font-light text-ink-soft">Retrouve ici les étapes de ton accompagnement, organisées par phase.</p>
      </div>

      <div className="grid gap-6 md:grid-cols-2">
        {phases.map((p, i) => {
          const Icon = p.icon;
          return (
            <motion.button
              key={p.id}
              data-testid={`phase-card-${p.id}`}
              onClick={() => navigate(`/espace/parcours/${p.id}`)}
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.08 }}
              className="group overflow-hidden rounded-2xl border border-line bg-white text-left shadow-card transition hover:-translate-y-0.5 hover:shadow-editorial"
            >
              <div className="relative h-56 overflow-hidden sm:h-64">
                <img
                  src={p.image}
                  alt={p.title}
                  className="absolute inset-0 h-full w-full object-cover transition duration-700 group-hover:scale-105"
                />
                {customProg && (
                  <div data-testid={`phase-cover-${p.id}`} className="absolute inset-0 flex flex-col items-center justify-center bg-[#2D181E]/30 backdrop-blur-md">
                    <span className="font-logo text-4xl italic text-white">{p.overline}</span>
                    <span className="mt-1 text-[11px] text-white/80">{p.caption}</span>
                  </div>
                )}
              </div>
              <div className="flex items-center gap-2.5 px-5 py-4">
                <Icon size={18} className="shrink-0 text-bordeaux" />
                <span className="font-sans text-sm font-semibold tracking-wide text-ink">{p.title}</span>
              </div>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
}
